import React from 'react';
import { ArrowDown, ArrowUpRight, ShieldCheck, MoveUpRight } from 'lucide-react';
import { Button } from './ui/button';
import { WhatsAppLink, WhatsAppIcon } from './WhatsAppLink';

export const Hero = () => (
  <>
    <section id="home" className="hero-section" aria-labelledby="hero-title" data-testid="hero-section">
      <img className="hero-photo" src="/images/hero-lobby-fatt-panel.webp" alt="Hall contemporâneo com dois elevadores em aço inox e painel digital com a logo FATT Elevadores" fetchPriority="high" width="1800" height="1013" data-testid="hero-image" />
      <div className="hero-shade" />
      <div className="site-container hero-inner">
        <div className="hero-content">
          <p className="eyebrow hero-eyebrow" data-testid="hero-brand">FATT ELEVADORES <span /> TRANSPORTE VERTICAL</p>
          <h1 id="hero-title" data-testid="hero-title">Tecnologia e<br />segurança para<br /><span>ir além.</span></h1>
          <p className="hero-description" data-testid="hero-description">Soluções completas em transporte vertical.<br className="desktop-break" /> Perto de você, em todo o Brasil.</p>
          <div className="hero-actions">
            <Button asChild className="fatt-button button-red"><WhatsAppLink subject="um projeto de transporte vertical" testId="hero-whatsapp"><WhatsAppIcon /> Falar no WhatsApp <ArrowUpRight size={17} /></WhatsAppLink></Button>
            <a className="hero-secondary" href="#solutions" data-testid="hero-solutions">Conheça nossas soluções <ArrowDown size={17} /></a>
          </div>
        </div>
        <div className="hero-image-note" data-testid="hero-image-caption"><span>ENGENHARIA QUE APROXIMA.</span></div>
      </div>
    </section>
    <div className="credentials-band" data-testid="credentials-band"><div className="site-container credentials-inner">
      <div className="experience" data-testid="experience-highlight"><strong>10<span>+</span></strong><p>Mais de 10 anos de<br /><b>experiência da equipe</b></p></div>
      <div className="credential"><ShieldCheck aria-hidden="true" /><p>Equipe capacitada em<br /><b>NR10 e NR12</b></p></div>
      <div className="credential"><MoveUpRight aria-hidden="true" /><p>Do projeto à manutenção.<br /><b>Uma solução completa.</b></p></div>
      <a href="#about" className="credentials-more" data-testid="hero-about" aria-label="Conheça a FATT Elevadores"><ArrowDown size={22} /></a>
    </div></div>
  </>
);